import { useState, useEffect } from "react";

const getTimeUntil5amUTC = () => {
  const now = new Date();
  const next = new Date(now);
  next.setUTCHours(5, 0, 0, 0);
  if (now >= next) next.setUTCDate(next.getUTCDate() + 1);
  return next.getTime() - now.getTime();
};

export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(getTimeUntil5amUTC());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeUntil5amUTC());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const hours = Math.floor(timeLeft / 3600000);
  const minutes = Math.floor((timeLeft % 3600000) / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);

  return { hours, minutes, seconds };
};
